module.exports = __webpack_public_path__ + "static/media/flag-km.ad51d2bf.webp";